import Subscriptions from "./Subscription/Subscriptions";
import Payments from "./Payments";
import PaymentMethods from "./PaymentMethods";

const Billing = () => {
    return (
        <>
            <Subscriptions />
            <PaymentMethods />
            <Payments />
        </>
    )
};

export default Billing;
